import * as React from "react";
import { forwardRef } from "react";
const SvgToolElipse = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="#726f7e" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round"><path d="M12 19C17.5228 19 22 15.866 22 12C22 8.13401 17.5228 5 12 5C6.47715 5 2 8.13401 2 12C2 15.866 6.47715 19 12 19Z" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
const ForwardRef = forwardRef(SvgToolElipse);
export { ForwardRef as ReactComponent };